import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { loadingState } from "src/atom/LoadingState";
import { useRecoilState } from "recoil";
import {
  addLabels,
  getHistoryTickets,
  getTicketLabels,
  getTicketTemplate,
  replyTicket,
  fetchAttachments,
} from "src/services/Tickets/StudentTicketService";
import { CButton, CDropdown } from "@coreui/react";
import { alertMessageState } from "src/atom/LoadingState";
import Sidebar from "./Sidebar";
import TicketDescription from "../HelpDesk/TicketDescription";
import TicketingReply from "../HelpDesk/TicketingReply";

function ViewTicketHistory() {
  const addTicketObj = {
    comment: "",
    status: "",
  };
  const location = useLocation();
  const [formData, setFormData] = useState(addTicketObj);
  var { id, nextViewHistory } = location.state || {};
  const [ticketId, setTicketId] = useState(null);
  const [, setAlertMessage] = useRecoilState(alertMessageState);
  const [, setIsSubmitted] = useState(false);
  const [, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [, enableLoader] = useRecoilState(loadingState);
  const [data, setData] = useState([]);
  const [ticketData, setTicketData] = useState({});
  const [template, setTemplate] = useState([]);
  const [label, setLabel] = useState([]);
  const [response, setResponse] = useState();
  const [, setSelectedStatus] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const ticketQuery = ticketData?.query || "";

  const fetchingTemplate = async () => {
    const response = await getTicketTemplate({
      pageNumber: pagination.currentPage,
      search: pagination.search,
      pageSize: pagination.size,
    });
    setTemplate(response.body);
    setPagination((prevValue) => ({
      ...prevValue,
      totalItems: response.body.totalElements,
      totalPages: Math.ceil(response.body.totalElements / pagination.size),
    }));
  };

  const [validationErrors, setValidationErrors] = useState({
    ticketId: "",
    comment: "",
    file: "",
  });

  const handleReplyClick = () => {
    setVisible(!visible);
    setFormData({
      ...formData,
      ["comment"]: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    const isValid = validateForm();
    if (isValid) {
      enableLoader(true);
      const formValues = new FormData();
      if (selectedFile !== undefined) {
        formValues.append("files", selectedFile);
      }
      formValues.append("ticket", JSON.stringify(formData));
      setValidationErrors({});
      setLoading(true);
      const response = await replyTicket(formValues, ticketId);
      if (response.success) {
        setFormData(addTicketObj);
        setVisible(false);
      } else {
        setAlertMessage(response.message);
      }
      enableLoader(false);
      setLoading(false);
      fetchingTicketHistory(ticketId);
    }
  };

  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!formData.comment) {
      errors.comment = "Please provide Ticket Description.";
      isValid = false;
    }

    setValidationErrors(errors);
    return isValid;
  };

  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/adminHelpDesk");
  };

  const getAllLabels = async () => {
    var getLabelss = async () => {
      var response = await getTicketLabels();
      if (response.success) {
        setLabel(response.body.labels);
      } else {
        setAlertMessage(response.message);
      }
    };
    getLabelss();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleTemplateChange = (templateId) => {
    const selectedTemplate = template?.templates.find(
      (temp) => temp.id == templateId
    );
    setFormData((prevData) => ({
      ...prevData,
      comment: selectedTemplate?.content || "",
    }));
  };

  const [pagination, setPagination] = useState({
    currentPage: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    next: "",
    prev: "",
    size: 10,
    search: "",
  });

  useEffect(() => {
    getAllLabels();
    if (id) {
      setTicketId(id);
      fetchingTicketHistory(id);
    }
  }, [id]);

  useEffect(() => {
    fetchingTemplate();
  }, [pagination.currentPage, pagination.size]);

  const handleLabelChange = async (labelId) => {
    const response = await addLabels(labelId, [id]);
    if (response.success) {
      setFormData({});
      setVisible(false);
      fetchingTicketHistory(id);
    } else {
      setAlertMessage(response.message);
    }
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [historyIndex, setHistoryIndex] = useState(0);
  const handleNextButton = () => {
    if (historyIndex < nextViewHistory.length) {
      const element = nextViewHistory[historyIndex];
      fetchingTicketHistory(element);
      setHistoryIndex(historyIndex + 1);
    } else {
    }
  };

  const fetchingTicketHistory = async (ticketId) => {
    const response = await getHistoryTickets(ticketId);
    const tickets = response.body.Tickets;
    if (tickets?.length > 0) {
      const [firstTicket, ...remainingTickets] = tickets;
      setTicketData(firstTicket);
      setData(remainingTickets);
    }
  };

  const handleLinkSubmit = async (ticketHistoryId) => {
    try {
      const response = await fetchAttachments(ticketHistoryId);
      if (response.success) {
        setIsSidebarOpen(!isSidebarOpen);
        setResponse(response.body);
      } else {
        setAlertMessage(response.message);
      }
    } catch (error) {
    } finally {
      enableLoader(false);
    }
  };

  return (
    <>
      {isSidebarOpen && <Sidebar isOpen={isSidebarOpen} response={response} />}

      <div
        className="card"
        style={{
          marginRight: isSidebarOpen ? "550px" : "0",
          transition: "margin-left 0.3s",
        }}
      >
        <div className="card" style={{ overflow: "hidden" }}>
          <div
            className="card-header text-white"
            style={{ backgroundColor: "#3C4B64", fontWeight: "bold" }}
          >
            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-between">
              <span className="mr-auto mb-2 mb-sm-0">Ticket History</span>
              <div className="d-flex justify-content-end">
                <div className="mb-2 mb-sm-0">
                  <select
                    name="state"
                    value={formData.name ? formData.name : ""}
                    onChange={(e) => handleLabelChange(e.target.value)}
                    className={`form-control ${
                      validationErrors.state ? "is-invalid" : ""
                    }`}
                    id="state"
                    style={{
                      backgroundColor: "#321fdb",
                      color: "rgb(255 255 255 / 87%)",
                      border: "none",
                      cursor: "pointer",
                      width: "100%",
                    }}
                  >
                    <option value=""> Assign Label</option>
                    {label?.map((state) => (
                      <option key={state.id} value={state.id}>
                        {state.name}
                      </option>
                    ))}
                  </select>
                </div>
                <CButton
                  className="ms-2"
                  style={{ marginRight: "10px" }}
                  onClick={() => {
                    handleButtonClick();
                  }}
                >
                  Back
                </CButton>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-6 mb-2">
                <div className="row">
                  <div className="col-md-4">
                    <label
                      htmlFor="ticketNumber"
                      style={{ fontWeight: "bold" }}
                    >
                      Ticket Number:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div>{ticketData?.ticketNumber}</div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <label htmlFor="Label" style={{ fontWeight: "bold" }}>
                      Label:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div>{ticketData?.label || "N/A"}</div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <label
                      htmlFor="candidateName"
                      style={{ fontWeight: "bold" }}
                    >
                      Candidate Name:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div>{ticketData?.raisedBy?.name}</div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <label
                      htmlFor="registerationNumber"
                      style={{ fontWeight: "bold" }}
                    >
                      Registeration Number:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div>{ticketData?.raisedBy?.userId}</div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <label htmlFor="raisedOn" style={{ fontWeight: "bold" }}>
                      Raised On:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div>{ticketData?.raisedOn}</div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-2">
                <div className="row" style={{ marginTop: "10px" }}>
                  <div className="col-md-4">
                    <label
                      htmlFor="ticketAttachments"
                      style={{ fontWeight: "bold" }}
                    >
                      Status:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div className="mb-0">
                      <div className="ms-4">{ticketData?.status}</div>
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <label
                      htmlFor="ticketCategory"
                      style={{ fontWeight: "bold" }}
                    >
                      Ticket Category:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div className="ms-4">
                      {ticketData?.ticketCategorytitle}
                    </div>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <label
                      htmlFor="ticketCategory"
                      style={{ fontWeight: "bold" }}
                    >
                      Ticket Sub-Category:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div className="ms-4">
                      {ticketData?.ticketSubCategorytitle}
                    </div>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "10px" }}>
                  <div className="col-md-4">
                    <label
                      htmlFor="ticketAttachments"
                      style={{ fontWeight: "bold" }}
                    >
                      Ticket Attachments:
                    </label>
                  </div>
                  <div className="col-md-8">
                    <div>
                      <button
                        className="btn btn-link"
                        rel="noopener noreferrer"
                        onClick={() => {
                          handleLinkSubmit(ticketData.ticketHistoryId);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {ticketData.attachmentAdded ? "View attachment" : ""}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {!ticketData.newData ? (
          <TicketDescription query={ticketQuery} />
        ) : (
          <TicketNewDataAdmin
            data={ticketData}
            recallticketHistory={fetchingTicketHistory}
          />
        )}

        <div className="card mt-2">
          <TicketingReply data={data} handleLinkSubmit={handleLinkSubmit} />
          <div className="mt-3 mb-5 ms-5">
            {!(
              ticketData.status == "RESOLVED" || ticketData.status == "CLOSED"
            ) && (
              <button
                type="submit"
                className="btn btn-sm btn-success text-white me-2"
                onClick={() => {
                  handleReplyClick();
                }}
              >
                Send Reply
              </button>
            )}
            <button
              type="nextPage"
              className="btn btn-sm btn-success text-white me-2"
              onClick={() => {
                handleNextButton();
              }}
            >
              Next Ticket History
            </button>
            {visible && (
              <div style={{ overflow: "Hidden" }}>
                <div className="card-body">
                  <form>
                    <div className="row mb-2">
                      <div className="row mb-2">
                        <div className="col-md-3 mb-2 ms-5">
                          <label htmlFor="totalSeats">Select Templates</label>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group ms-1">
                            <select
                              name="ticketCategoryId"
                              value={formData?.ticketCategoryId?.id}
                              className={`form-control`}
                              onChange={(e) => {
                                handleTemplateChange(e.target.value);
                              }}
                              id="ticketCategoryId"
                            >
                              <option>Select Template</option>
                              {template?.templates.map((result) => (
                                <option key={result.id} value={result.id}>
                                  {result.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-3 mb-2 ms-5">
                          <label htmlFor="email">Ticket Description</label>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <textarea
                              rows="6"
                              cols="50"
                              className={`form-control ${
                                validationErrors.comment ? "is-invalid" : ""
                              }`}
                              id="comment"
                              placeholder="Please describe your ticket"
                              name="comment"
                              value={formData?.comment}
                              onChange={handleInputChange}
                            />
                            {validationErrors.comment && (
                              <div className="invalid-feedback">
                                {validationErrors.comment}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-md-3 mb-2 ms-5">
                          <label htmlFor="file">Attachment</label>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <input type="file" className="form-control" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5">
                      {ticketData.status != "RESOLVED" ||
                        (ticketData.status != "CLOSED" && (
                          <button
                            type="submit"
                            className="btn btn-success text-white ms-md-auto"
                            style={{ marginLeft: "0", marginRight: "10px" }}
                            onClick={(e) => handleSubmit(e)}
                          >
                            Submit
                          </button>
                        ))}

                      <CDropdown>
                        <select
                          name="status"
                          onChange={handleStatusChange}
                          className={`form-control ${
                            validationErrors.documentId ? "is-invalid" : ""
                          }`}
                          id="status"
                          value={formData.status}
                          style={{
                            marginLeft: "10px",
                            backgroundColor: "#2eb85c",
                            border: "none",
                            color: "white",
                            boxShadow: "none",
                          }}
                        >
                          <option value="" className="">
                            Assign Status
                          </option>
                          <option key="CLOSED" value="CLOSED">
                            CLOSE
                          </option>
                          <option key="RESOLVED" value="RESOLVED">
                            RESOLVE
                          </option>
                        </select>
                      </CDropdown>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewTicketHistory;
